export const mockData = {
  companyInfo: {
    name: "Smile a Pal",
    tagline: "NDIS Support Services",
    phone: "0423 400 072",
    location: "Auburn",
    address: "298 Chisholm Road, Auburn NSW 2144",
    email: "info@smileapal.com.au"
  },
  
  hero: {
    title: "Empowering Lives with ",
    titleHighlight: "Compassionate Disability Support",
    description: "Dedicated to helping you achieve your personal goals with tailored support services through the NDIS.",
    ctaText: "Get Care and Support",
    image: "https://images.unsplash.com/photo-1764006145420-df3006edf060"
  },
  
  services: [
    {
      id: 1,
      title: "Accommodation & Tenancy Support",
      code: "0101",
      description: "We support participants to understand and maintain their tenancy, build independent living skills, and navigate housing-related matters in line with their NDIS plan.",
      category: "Housing & Living Supports",
      image: "https://images.unsplash.com/photo-1576765608866-5b51046452be"
    },
    {
      id: 2,
      title: "Daily Tasks / Shared Living",
      code: "0115",
      description: "We assist participants with everyday tasks in shared or supported living environments, supporting routine, confidence, and independence.",
      category: "Housing & Living Supports",
      image: "https://customer-assets.emergentagent.com/job_disability-care-hub/artifacts/cdzo7rcz_dailytask2.jpeg"
    },
    {
      id: 3,
      title: "Specialist Disability Accommodation (SDA)",
      code: "0131",
      description: "We provide SDA-related supports in accordance with SDA rules, participant eligibility, and individual NDIS plans. Availability is subject to suitability and compliance requirements.",
      category: "Housing & Living Supports",
      image: "https://customer-assets.emergentagent.com/job_disability-care-hub/artifacts/0uz5in0m_specialistdisbilityaccomodation.jpeg"
    },
    {
      id: 4,
      title: "Assistance with Personal Activities",
      code: "0107",
      description: "We provide respectful, non-clinical support with daily personal activities such as personal hygiene, dressing, and meal preparation. Supports are delivered with appropriate safeguards, supervision, and participant-focused planning.",
      category: "Personal & Daily Supports",
      image: "https://customer-assets.emergentagent.com/job_disability-care-hub/artifacts/1unaging_assistancewithpersonalactivities.jpeg"
    },
    {
      id: 5,
      title: "Assist Travel / Transport",
      code: "0108",
      description: "We support participants to access the community, appointments, and daily activities in line with their NDIS goals.",
      category: "Personal & Daily Supports",
      image: "https://customer-assets.emergentagent.com/job_disability-care-hub/artifacts/p2idqkej_assistedtravel.jpeg"
    },
    {
      id: 6,
      title: "Assist Access / Maintain Employment",
      code: "0102",
      description: "We support participants to prepare for, find, and maintain employment by building confidence, workplace skills, and independence.",
      category: "Capacity Building & Employment",
      image: "https://customer-assets.emergentagent.com/job_disability-care-hub/artifacts/k0je0ax3_assistaccess_maintainemployment.jpeg"
    },
    {
      id: 7,
      title: "Development of Life Skills",
      code: "0117",
      description: "We help participants develop everyday life skills, including communication, budgeting, cooking, and independent living skills.",
      category: "Capacity Building & Employment",
      image: "https://images.unsplash.com/photo-1773227054058-afd18b554e8f"
    },
    {
      id: 8,
      title: "Innovative Community Participation",
      code: "0116",
      description: "We deliver structured community-based programs that support skill development, confidence, and social connection.",
      category: "Community & Group Supports",
      image: "https://images.pexels.com/photos/7551677/pexels-photo-7551677.jpeg"
    },
    {
      id: 9,
      title: "Participate in Community",
      code: "0125",
      description: "We assist participants to engage in social, recreational, and community activities aligned with their interests and goals.",
      category: "Community & Group Supports",
      image: "https://images.unsplash.com/photo-1587556930720-58ec521056a5"
    },
    {
      id: 10,
      title: "Group / Centre-Based Activities",
      code: "0136",
      description: "We offer group activities designed to encourage social interaction, learning, and enjoyment in a supportive environment.",
      category: "Community & Group Supports",
      image: "https://images.unsplash.com/photo-1765896387387-0538bc9f997e"
    }
  ],
  
  resources: [
    {
      id: 1,
      title: "Download Our Support Guide",
      description: "Your Comprehensive Guide to SmileAPal Services",
      type: "PDF Guide",
      icon: "FileText",
      bgColor: "#0C1110",
      fileUrl: "https://customer-assets.emergentagent.com/job_disability-care-hub/artifacts/3lzfjd4t_Smile_A_Pal_NDIS_Support_Guide.pdf",
      fileName: "Smile_A_Pal_NDIS_Support_Guide.pdf"
    },
    {
      id: 2,
      title: "Download Our Plan Guide",
      description: "Essential resources for NDIS participants",
      type: "Resource Kit",
      icon: "Download",
      bgColor: "#157A85",
      fileUrl: "https://customer-assets.emergentagent.com/job_disability-care-hub/artifacts/abnyltjk_Smile_A_Pal_NDIS_Support_Plan_Guide.pdf",
      fileName: "Smile_A_Pal_NDIS_Support_Plan_Guide.pdf"
    }
  ],
  
  blogPosts: [
    {
      id: 1,
      title: "Navigating the NDIS with Confidence",
      excerpt: "Learn the essential steps to make the most of your NDIS plan and achieve your goals.",
      image: "https://images.unsplash.com/photo-1772791002745-e9d5a1ff81bd",
      category: "NDIS Support",
      date: "March 15, 2025"
    },
    {
      id: 2,
      title: "Building Independence Through Daily Living Support",
      excerpt: "Discover how personalized daily living support can enhance your independence and quality of life.",
      image: "https://images.unsplash.com/photo-1653370205143-d07cbf28d668",
      category: "Daily Living",
      date: "March 12, 2025"
    },
    {
      id: 3,
      title: "Community Participation: Making Meaningful Connections",
      excerpt: "Explore the benefits of community participation programs and how they can enrich your life.",
      image: "https://images.unsplash.com/photo-1773227054058-afd18b554e8f",
      category: "Community",
      date: "March 8, 2025"
    }
  ],
  
  accessibilityFeatures: [
    {
      id: 1,
      label: "Increase Text",
      icon: "Type"
    },
    {
      id: 2,
      label: "Decrease Text",
      icon: "Type"
    },
    {
      id: 3,
      label: "Grayscale",
      icon: "Contrast"
    },
    {
      id: 4,
      label: "High Contrast",
      icon: "Sun"
    },
    {
      id: 5,
      label: "Negative Contrast",
      icon: "Moon"
    },
    {
      id: 6,
      label: "Light Background",
      icon: "Circle"
    },
    {
      id: 7,
      label: "Links Underline",
      icon: "Underline"
    },
    {
      id: 8,
      label: "Readable Font",
      icon: "AlignLeft"
    }
  ],
  
  features: [
    {
      id: 1,
      title: "Personalized Care Plans",
      description: "Tailored support designed around your unique needs and goals.",
      icon: "Heart"
    },
    {
      id: 2,
      title: "Experienced Support Workers",
      description: "Qualified professionals dedicated to empowering your independence.",
      icon: "Users"
    },
    {
      id: 3,
      title: "24/7 Availability",
      description: "Round-the-clock support when you need it most.",
      icon: "Clock"
    }
  ],
  
  navigation: [
    { label: "Home", path: "/" },
    { label: "About Us", path: "#about" },
    { label: "Services", path: "#services" },
    { label: "NDIS", path: "https://www.ndis.gov.au/understanding-ndis/about-ndis" },
    { label: "Resources", path: "#resources" },
    { label: "Contact Us", path: "#contact" }
  ]
};